import { checkTrue } from '@mummssoftware/utils/utils';
import { ORDER_NOTE_ENTITY_TYPES } from './constants';
/** Orders Log addendum payload (snapshot from order row + guards). */

/** True when this order type supports Orders Log addendum. */
export const isOrderAddendumType = ordertypeshortname => !!ordertypeshortname && ORDER_NOTE_ENTITY_TYPES.includes(ordertypeshortname);
/**
 * Defense in depth for appendToOrder: claim must match a real order note.
 * Requires progressNoteId, isorder, and allowlisted ordertypeshortname.
 */

export const isValidOrderAppendPayload = (appendToOrder, payload) => {
  if (!appendToOrder || !payload) {
    return false;
  }

  if (!payload.progressNoteId) {
    return false;
  }

  if (!checkTrue(payload.isorder)) {
    return false;
  }

  if (!isOrderAddendumType(payload.ordertypeshortname)) {
    return false;
  }

  return true;
};